import React from 'react';
import { Link } from 'react-router-dom';
import './footer.css';
import logo from '../images/logo.png';
import { AiOutlineInstagram, AiOutlineLinkedin, AiOutlineWhatsApp } from 'react-icons/ai';
import { LEADERSHIP_CONTACTS, MEMBERSHIP_FORM_URL } from '../../constants/site';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: "Home", path: "/home" },
    { label: "About Us", path: "/about" },
    { label: "Events", path: "/events" },
    { label: "Careers", path: "/careers" },
  ];

  const resourceLinks = [
    { label: "Gallery", path: "/gallery" },
    { label: "Contact Us", path: "/contacts" },
    { label: "Become a Member", path: MEMBERSHIP_FORM_URL, external: true },
  ];

  const socialLinks = [
    { 
      icon: AiOutlineWhatsApp, 
      href: `https://api.whatsapp.com/send?phone=${LEADERSHIP_CONTACTS[0].whatsapp}`,
      label: "WhatsApp"
    },
    { 
      icon: AiOutlineLinkedin, 
      href: "https://www.linkedin.com/company/udsm-internal-audit-association/",
      label: "LinkedIn"
    },
    { 
      icon: AiOutlineInstagram, 
      href: "https://www.instagram.com/udiaa_udsm/",
      label: "Instagram"
    },
  ];

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-grid">
          {/* Brand Column */}
          <div className="footer-brand">
            <Link to="/home" className="footer-logo">
              <img src={logo} alt="UDIAA Logo" />
            </Link>
            <p className="footer-tagline">
              Shaping the future of Internal Audit professionals through education, 
              networking, and professional development.
            </p>
            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.href} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={social.label}
                >
                  <social.icon />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links-column">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link to={link.path}>{link.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div className="footer-links-column">
            <h4 className="footer-heading">Resources</h4>
            <ul className="footer-links">
              {resourceLinks.map((link, index) => (
                <li key={index}>
                  {link.external ? (
                    <a href={link.path} target="_blank" rel="noopener noreferrer">
                      {link.label}
                    </a>
                  ) : (
                    <Link to={link.path}>{link.label}</Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-heading">Contact Us</h4>
            <div className="contact-info-list">
              <div className="contact-info-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span>Dar es Salaam, Tanzania</span>
              </div>
              <div className="contact-info-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                <a href="mailto:udsmudiaa@gmail.com">udsmudiaa@gmail.com</a>
              </div>
              <div className="contact-info-item">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                </svg>
                <span className="footer-phone-links">
                  {LEADERSHIP_CONTACTS.map((contact) => (
                    <a key={contact.phone} href={`tel:${contact.phone}`}>{contact.display}</a>
                  ))}
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-copyright">
            <p>&copy; {currentYear} UDIAA. All rights reserved.</p>
          </div>
          <div className="footer-bottom-links">
            <span>University of Dar es Salaam Internal Audit Association</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
